/* Graph-paper spotlight: a soft circle of graph paper that trails the mouse across the page background.
   This only moves --mx/--my on <html> and toggles .pg-spot; the look lives in styles.css (body::before).
   Mouse only: touch and pen never turn it on, and reduced motion keeps the static grid. */
const EASE = 0.35; // share of the remaining distance covered each frame; lower trails further behind

export function mountSpotlight(root: HTMLElement = document.documentElement): void {
  const still = matchMedia("(prefers-reduced-motion: reduce)");
  let x = 0, y = 0, tx = 0, ty = 0, frame = 0, shown = false;

  const paint = (): void => {
    root.style.setProperty("--mx", `${x.toFixed(1)}px`);
    root.style.setProperty("--my", `${y.toFixed(1)}px`);
  };
  const step = (): void => {
    x += (tx - x) * EASE; y += (ty - y) * EASE;
    if (Math.abs(tx - x) + Math.abs(ty - y) < 0.5) { x = tx; y = ty; frame = 0; } else frame = requestAnimationFrame(step);
    paint();
  };
  const show = (on: boolean): void => {
    if (on === shown) return;
    shown = on; root.classList.toggle("pg-spot", on);
  };

  addEventListener("pointermove", e => {
    if (e.pointerType !== "mouse" || still.matches) return show(false);
    tx = e.clientX; ty = e.clientY;
    // coming back in: start where the mouse is rather than gliding over from where it left
    if (!shown) { x = tx; y = ty; paint(); show(true); return; }
    if (!frame) frame = requestAnimationFrame(step);
  }, { passive: true });
  root.addEventListener("mouseleave", () => show(false));
  addEventListener("blur", () => show(false));
}
